<template>
  <div v-bind="$attrs" :class="className">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "GridCol",
  props: {
    cols: {
      type: [Number, String] as unknown as () => number | string | null,
      default: null,
    },
  },
  setup(props) {
    const className = computed(() => {
      if (props.cols == null) {
        return "col";
      }
      return `col-${props.cols}`;
    });
    return { className };
  },
});
</script>
